import type { Action } from 'redux';

import type { GetApiB2bGetStaticsResponse } from '/api';
import normaliseError, { type NormaliseErrorInput } from '/shared/functions/normaliseError';
import type { NormalisedError } from '/index';

export type StaticPropsQuestion = GetApiB2bGetStaticsResponse['questionStatics'][number];
export type StaticPropsCountryRegion = GetApiB2bGetStaticsResponse['countryRegions'][number];
export type StaticPropsEgrid = GetApiB2bGetStaticsResponse['egrids'][number];

export interface StaticPropsState {
  fetching: boolean;
  fetched: boolean | null;
  error: NormalisedError | null;
  questionStatics: GetApiB2bGetStaticsResponse['questionStatics'];
  egrids: GetApiB2bGetStaticsResponse['egrids'];
  countryRegions: GetApiB2bGetStaticsResponse['countryRegions'];
}

interface InitiateStaticPropLoadRejectedAction extends Action {
  type: 'INITIATE_STATIC_PROP_LOAD_REJECTED';
  error: NormaliseErrorInput;
}

interface InitiateStaticPropLoadStartedAction extends Action {
  type: 'INITIATE_STATIC_PROP_LOAD_STARTED';
}

interface InitiateStaticPropLoadFulfilledAction extends Action {
  type: 'INITIATE_STATIC_PROP_LOAD_FULFILLED';
  staticProps: Partial<Pick<StaticPropsState, 'questionStatics' | 'egrids' | 'countryRegions'>>;
}

type StaticPropsAction =
  | InitiateStaticPropLoadRejectedAction
  | InitiateStaticPropLoadStartedAction
  | InitiateStaticPropLoadFulfilledAction;

const defaultState: StaticPropsState = {
  fetching: false,
  fetched: null,
  error: null,
  questionStatics: [],
  egrids: [],
  countryRegions: [],
};

function reducer(state: StaticPropsState = defaultState, action: StaticPropsAction): StaticPropsState {
  switch (action.type) {
    case 'INITIATE_STATIC_PROP_LOAD_REJECTED': {
      const { error } = action;
      return {
        ...defaultState,
        error: normaliseError(error),
        fetching: false,
        fetched: false,
      };
    }
    case 'INITIATE_STATIC_PROP_LOAD_STARTED': {
      return {
        ...defaultState,
        fetching: true,
        fetched: false,
      };
    }

    case 'INITIATE_STATIC_PROP_LOAD_FULFILLED': {
      const { staticProps } = action;

      return {
        ...state,
        ...staticProps,
        error: null,
        fetching: false,
        fetched: true,
      };
    }
    default:
      return state;
  }
}

export default reducer;
